import { HttpClient } from './client'
import { TokenManager } from '../auth/tokenManager'

export interface EvidenceSurvey {
  id: string
  label: string
}

export interface EvidenceInterviewNote {
  noteId: string
  interviewLabel: string
  intervieweeName: string | null
}

export interface EvidenceDocument {
  id: string
  fileName: string
  type: 'survey' | 'interview'
}

export interface ConfidenceEvidencePayload {
  surveys: EvidenceSurvey[]
  interviewNotes: EvidenceInterviewNote[]
  documents: EvidenceDocument[]
}

export async function fetchConfidenceEvidence(
  mindmapId: string,
  nodeId: string
): Promise<ConfidenceEvidencePayload | null> {
  const headers = await TokenManager.getAuthHeaders()
  const result = await HttpClient.get<ConfidenceEvidencePayload>(
    `/mindmaps/${mindmapId}/nodes/${nodeId}/confidence-evidence`,
    headers
  )
  if (result.error) return null
  return result.data ?? null
}
